<template>
	<section class="new-event-hotel-success">
		<header class="new-event-hotel-success__header">
			<div class="new-event-hotel-success__icon">
				<img :src="hotelIcon" alt="">
			</div>

			<div>
				<h2>{{message.title}}</h2>
				<p>{{message.text}}</p>
				<a v-if="bankTicketUrl" :href="bankTicketUrl" target="_blank" rel="noopener">
					{{message.bankTicket}}
				</a>
			</div>
		</header>

		<div class="new-event-hotel-success__divider"></div>

		<nav class="new-event-hotel-success__options" aria-label="Opcoes promocionais">
			<button
				v-for="option in promotionalOptions"
				:key="option.resource"
				type="button"
				@click="$emit('select-option', option.resource)"
			>
				<img :src="option.icon" :alt="option.label">
				<span>{{option.label}}</span>
			</button>
		</nav>

		<p class="new-event-hotel-success__promo">
			<strong>{{message.promoTitle}}</strong>
			<span>{{message.promoText}}</span>
		</p>
	</section>
</template>

<script>
import { translate } from '../../assets/translations';

const OPTION_ICON_BASE = '/static/buttons/new';

export default {
	props: {
		bankTicketUrl: {
			type: String,
			default: '',
		},
	},
	computed: {
		hotelIcon() {
			return `${OPTION_ICON_BASE}/hotel-reservation-success.svg`;
		},
		message() {
			const messages = {
				Pt: {
					title: 'Seu pagamento foi efetuado com sucesso.',
					text: 'Estamos processando sua reserva e em breve o voucher de hospedagem sera encaminhado ao seu e-mail.',
					promoTitle: 'Aproveite para reservar a sua passagem aerea, passeios e traslados.',
					promoText: 'CONFIRA OS NOSSOS PRECOS PROMOCIONAIS!',
					bankTicket: 'Visualizar boleto',
				},
				En: {
					title: 'Your payment was completed successfully.',
					text: 'We are processing your booking and the hotel voucher will be sent to your email shortly.',
					promoTitle: 'Take this opportunity to book flights, tours and transfers.',
					promoText: 'CHECK OUR PROMOTIONAL RATES!',
					bankTicket: 'View bank ticket',
				},
				Sp: {
					title: 'Su pago se realizo con exito.',
					text: 'Estamos procesando su reserva y pronto enviaremos el voucher de hospedaje a su email.',
					promoTitle: 'Aproveche para reservar su pasaje aereo, tours y traslados.',
					promoText: 'CONSULTE NUESTROS PRECIOS PROMOCIONALES!',
					bankTicket: 'Ver boleto',
				},
			};
			return messages[this.$store.state.language.symbol] || messages.Pt;
		},
		optionLabels() {
			return translate(this.$store.state.language).eventPage.optionLabels;
		},
		promotionalOptions() {
			return [
				{
					resource: 'flight-request',
					icon: `${OPTION_ICON_BASE}/flight.svg`,
					label: this.optionLabels.flightReservation,
				},
				{
					resource: 'transfer',
					icon: `${OPTION_ICON_BASE}/transfer.svg`,
					label: this.optionLabels.transferReservation,
				},
				{
					resource: 'local-tour',
					icon: `${OPTION_ICON_BASE}/local-tour.svg`,
					label: this.optionLabels.localTours,
				},
			];
		},
	},
};
</script>

<style scoped lang="scss">
.new-event-hotel-success {
	box-sizing: border-box;
	width: 100%;
	min-height: 392px;
	padding: 68px 66px 57px;
	border: 1px solid #d7d7d7;
	border-radius: 0;
	background: #ffffff;
	color: #5a5a5a;
}

.new-event-hotel-success__header {
	display: flex;
	align-items: flex-start;
	gap: 28px;
}

.new-event-hotel-success__icon {
	flex: 0 0 80px;
	width: 80px;
	height: 75px;
}

.new-event-hotel-success__icon img {
	display: block;
	width: 80px;
	height: 75px;
	object-fit: contain;
}

.new-event-hotel-success h2 {
	margin: 0 0 4px;
	color: #002c41;
	font-size: 22px;
	font-weight: 700;
	line-height: 26px;
}

.new-event-hotel-success p,
.new-event-hotel-success a {
	margin: 0;
	font-size: 18px;
	font-weight: 400;
	line-height: 40px;
}

.new-event-hotel-success a {
	display: inline-flex;
	margin-top: 10px;
	color: #e89127;
	font-weight: 700;
	text-decoration: none;
}

.new-event-hotel-success__divider {
	height: 1px;
	margin: 55px 0 43px;
	background: rgba(90, 90, 90, .6);
}

.new-event-hotel-success__options {
	display: flex;
	flex-wrap: wrap;
	gap: 7px;
	margin-bottom: 25px;
}

.new-event-hotel-success__options button {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	box-sizing: border-box;
	width: 101px;
	min-height: 92px;
	padding: 11px 7px 10px;
	border: 1.5px solid #d9d9d9;
	border-radius: 25px;
	background: #ffffff;
	color: #5da3bd;
	cursor: pointer;
	font-family: inherit;
	font-size: 13px;
	font-weight: 500;
	line-height: 15px;
	text-align: center;
}

.new-event-hotel-success__options img {
	display: block;
	width: 42px;
	height: 42px;
	margin-bottom: 5px;
	object-fit: contain;
}

.new-event-hotel-success__promo {
	display: grid;
	gap: 0;
	color: #5a5a5a;
	font-size: 18px;
	font-weight: 700;
	line-height: 40px;
}

.new-event-hotel-success__promo span {
	font-weight: 700;
}

@media (max-width: 900px) {
	.new-event-hotel-success {
		padding: 34px 24px 40px;
	}

	.new-event-hotel-success__header {
		display: grid;
	}

	.new-event-hotel-success h2 {
		font-size: 20px;
		line-height: 25px;
	}

	.new-event-hotel-success p,
	.new-event-hotel-success a,
	.new-event-hotel-success__promo {
		font-size: 15px;
		line-height: 27px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/hotel-reservation/EndingReservation.vue